import {NgModule} from '@angular/core';
import { BannersComponent } from './banners.component';
import { SwiperModule } from '../../../node_modules/angular2-useful-swiper';
import { BannersService } from './banners.service';
import {CommonModule} from '@angular/common';
//import {CategoriesListRoutingModule} from './category-list-routing.module';
import { SafeHtmlPipe } from "./banner.pipe"

@NgModule({
  declarations: [BannersComponent, SafeHtmlPipe],
  providers: [BannersService],
  imports: [CommonModule,SwiperModule],
  exports: [BannersComponent]
})
export  class BannersModule {
}



// WEBPACK FOOTER //
// ./src/app/banners/banners.module.ts